'use strict';

require('prop-types');
var React = require('react');
var StarIcon = require('../Icons/StarIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function PartialNumberStarRating(_ref) {
  var rating = _ref.rating,
      size = _ref.size;

  var getFullRating = function getFullRating() {
    return Math.floor(rating);
  };

  var getPartialRating = function getPartialRating() {
    return Math.round((rating - Math.floor(rating)) * 100);
  };

  var buildFullStars = function buildFullStars(fullRating) {
    var fullStars = [];

    for (var i = 1; i <= 5; i++) {
      if (fullRating >= i) {
        fullStars.push(React__default["default"].createElement(StarIcon, {
          variant: "full",
          key: i,
          size: size
        }));
      }
    }

    return fullStars;
  };

  var buildPartialStar = function buildPartialStar(partialRating) {
    if (partialRating < 25) {
      return React__default["default"].createElement(StarIcon, {
        variant: "empty",
        key: "StarEmpty",
        size: size
      });
    } else if (partialRating >= 25 && partialRating < 50) {
      return React__default["default"].createElement(StarIcon, {
        variant: "oneQuarter",
        key: "StarOneQuarter",
        size: size
      });
    } else if (partialRating >= 50 && partialRating < 75) {
      return React__default["default"].createElement(StarIcon, {
        variant: "half",
        key: "StarHalfIcon",
        size: size
      });
    } else {
      return React__default["default"].createElement(StarIcon, {
        variant: "threeQuarters",
        key: "StarThreeQuarters",
        size: size
      });
    }
  };

  var buildEmptyStars = function buildEmptyStars(starsUsed) {
    var emptyStars = [];

    for (var i = starsUsed; i < 5; i++) {
      emptyStars.push(React__default["default"].createElement(StarIcon, {
        variant: "empty",
        key: i,
        size: size
      }));
    }

    return emptyStars;
  };

  var buildStars = function buildStars() {
    var stars = buildFullStars(getFullRating());

    if (stars.length < 5) {
      stars.push(buildPartialStar(getPartialRating()));
    }

    stars = stars.concat(buildEmptyStars(stars.length));
    return stars;
  };

  return React__default["default"].createElement(React.Fragment, null, buildStars());
}

module.exports = PartialNumberStarRating;
